import {KEY_DESTINATION_URL} from "~/constants/no-login-keys";
import {createContext, PropsWithChildren, useContext, useState} from "react";

interface LoginDestinationUrlContextProps {
  setDestinationUrl: (destinationUrl: string) => void;
  getDestinationUrl: () => string | null;
  clearDestinationUrl: () => void;
}

const LoginDestinationUrlContext = createContext<LoginDestinationUrlContextProps | undefined>(undefined);

export const isValueFromStorageTrue = (key: string): boolean => {
  return sessionStorage.getItem(key) === "true";
};

export const useLoginDestinationUrl = (): LoginDestinationUrlContextProps => {
  const context = useContext(LoginDestinationUrlContext);
  if (!context) {
    throw new Error("useLoginDestinationUrl must be used within a BlockingProvider");
  }
  return context;
};

export const LoginDestinationUrlProvider = ({children}: PropsWithChildren) => {
  const [destinationUrlState, setDestinationUrlState] = useState<string | null>(null);

  const setDestinationUrl = (destinationUrl: string) => {
    setDestinationUrlState(destinationUrl);
    sessionStorage.setItem(KEY_DESTINATION_URL, destinationUrl);
  };

  const getDestinationUrl = (): string | null => {
    if (destinationUrlState) {
      return destinationUrlState;
    }
    const storedDestinationUrl = sessionStorage.getItem(KEY_DESTINATION_URL);
    return storedDestinationUrl || null;
  };

  const clearDestinationUrl = () => {
    setDestinationUrlState(null);
    sessionStorage.removeItem(KEY_DESTINATION_URL);
  };

  return (
    <LoginDestinationUrlContext.Provider
      value={{
        setDestinationUrl,
        getDestinationUrl,
        clearDestinationUrl,
      }}
    >
      {children}
    </LoginDestinationUrlContext.Provider>
  );
};
